import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c(VContainer,{staticClass:"nav"},[_c(VCardTitle,[_c(VRow,{attrs:{"align":"center"}},[_c(VCol,{staticClass:"pr-0",attrs:{"cols":"2","sm":"2","lg":"1","align":"right"}},[_c(VAvatar,{staticClass:"page-icon teal mr-2 elevation-5"},[_c(VIcon,{staticClass:"white--text",attrs:{"large":""}},[_vm._v(" "+_vm._s(_vm.mdiTable)+" ")])],1)],1),_c(VCol,{staticClass:"pl-0",attrs:{"cols":"10","sm":"10","lg":"11"}},[_c('h2',{staticStyle:{"word-break":"normal"}},[_vm._v(" Member Utilizations ")])])],1)],1),_c(VDivider)],1),_c('UtilTable',{attrs:{"get-user-util":_vm.getUtil}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }